/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandVite = createReactComponent("brand-vite", "IconBrandVite", [
  ["path", { d: "M10 4.5l6 -1.5l-2 6.5l2 -.5l-4 7v-5l-3 1z", key: "svg-0" }],
  ["path", { d: "M15 6.5l7 -1.5l-10 17l-10 -17l7.741 1.5", key: "svg-1" }]
]);

export { IconBrandVite as default };
//# sourceMappingURL=IconBrandVite.js.map
